import { BaseMutationTypes } from '../BaseMutationTypes';

export class UserPreferencesMutationTypes extends BaseMutationTypes {
  public static readonly SetJobVerticalSlider = 'SET_JOB_VERTICAL_SLIDER';
  public static readonly SetWorkflowTreeView = 'SET_WORKFLOW_TREE_VIEW';
  public static readonly SetCanGetNextJob = 'SET_CAN_GET_NEXT_JOB';
  public static readonly SetLastSelectedWorkflowQueue = 'SET_LAST_SELECTED_WORKFLOW_QUEUE';
  public static readonly SetWorkflowQueueTableStateField = 'SET_WORKFLOW_QUEUE_TABLE_STATE_FIELD';
  public static readonly SetDocumentToStoreTargetDocumentType = 'SET_DOCUMENTTOSTORE_TARGET_DOCUMENT_TYPE';
  public static readonly SetDocumentToStoreTableFilters = 'SET_DOCUMENT_TO_STORE_TABLE_FILTERS';
  public static readonly RemoveDocumentTypeSelection = 'REMOVE_DOCUMENT_TYPE_SELECTION';
  public static readonly SetPinFilter = 'SET_PIN_FILTER';
  public static readonly SetIsHorizontalTabUp = 'SET_IS_HORIZONTAL_TAB_UP';
  public static readonly UpdateVuexPersistedState = 'UPDATE_VUEX_PERSISTED_STATE';

  public static readonly SetDocumentsToStoreTableSortProperties = 'SET_STORE_DOCUMENTS_TABLE-SORT';
  public static readonly AddSuppressedConfirmation = 'ADD_SUPPRESSED_CONFIRMATION';
  public static readonly RemoveSuppressedConfirmation = 'REMOVE_SUPPRESSED_CONFIRMATION';
  public static readonly SetDocumentsToStoreVerticalSlider = 'SET_DOCUMENTS_TO_STORE_VERTICAL_SLIDER';
  public static readonly SetDocumentToStoreCanGetNextDocument = 'SET_DOCUMENTTOSTORE_CAN_GET_NEXT_DOCUMENT';
}
